/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '@app/axios/axiosIns'


export const getAllDisplayCount = createAsyncThunk('admin/displayCount', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/admin/project/displayCount')
    return response.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getDashboardGraphData = createAsyncThunk('admin/deskboardGraph', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/admin/project/displayCount')
    return response.data
  } catch (error) {
    return rejectWithValue(error)
  }
})


interface DashboardState {
  isLoading: boolean
  error: any
  dashboardDisplayCount: any
  dashboardGraphData: any
}

const initialState: DashboardState = {
  isLoading: false,
  error: null,
  dashboardDisplayCount: null,
  dashboardGraphData: null
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: { resetState: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDisplayCount.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllDisplayCount.fulfilled, (state, action) => {
        state.isLoading = false
        state.dashboardDisplayCount = action.payload?.data
      })
      .addCase(getAllDisplayCount.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getDashboardGraphData.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getDashboardGraphData.fulfilled, (state, action) => {
        state.isLoading = false
        state.dashboardGraphData = action.payload?.data
      })
      .addCase(getDashboardGraphData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetState } = dashboardSlice.actions
export default dashboardSlice.reducer
